module.exports = __webpack_public_path__ + "static/Lamentum0-201a0be80d8630cb04bc9a5c49262ef8.webp";